import { Error, VerifiedOutlined } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import * as React from 'react';
import { useContext, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { EmailValid } from "../../../hooks/useValidateEmail";
import { EXHIBITION } from "../../../locales/components/namespaces";
import { RegistrationContext } from "../../form/form";
import { useSearchVisitor } from "../../../hooks/registration/useSearchVisitor";
import Autocomplete from "../../autocomplete/autocomplete";
import { defaultPreregistrationFields } from "../../customizeRegistration/defaultFields";
import { searchFieldMappings } from "../../../helpers/helpers";
import MobilePhone from "./mobilePhone";
import TaxisSearch from "./taxisSearch";

const SearchVisitor = (props) => {
	const {
		searchFieldRef,
		formik,
		values,
		field,
		textfieldProps
	} = props
	const { t } = useTranslation(EXHIBITION)
	const {
		interests,
		postalCodeFieldRef,
		phoneCodes,
		onPhoneCodeChange,
		defaultCountry,
		defaultPhoneCode,
		emailIsValid,
		validateEmail
	} = useContext(RegistrationContext)
	const { loading, options, fetchVisitors, onVisitorSelect, handleOptions } = useSearchVisitor(field.id)
	const enableSearch = !formik.values.fieldValues.id
	const fieldReturn = useMemo(() => {
		if (field.id === 'mobilePhone') {
			return (
				<MobilePhone
					defaultCountry={defaultCountry}
					defaultPhoneCode={defaultPhoneCode}
					searchFieldRef={searchFieldRef}
					fetchVisitors={fetchVisitors}
					display={'table'}
					options={options}
					searchFieldMappings={searchFieldMappings}
					defaultPreregistrationFields={defaultPreregistrationFields}
					field={field}
					textfieldProps={textfieldProps}
					loading={loading}
					searchAfterNoOfCharacters={3}
					handleOptions={handleOptions}
					onVisitorSelect={onVisitorSelect}
					interests={interests}
					postalCodeFieldRef={postalCodeFieldRef}
					enableSearch={enableSearch}
					values={values}
					phoneCodes={phoneCodes}
					onPhoneCodeChange={onPhoneCodeChange}
					formik={formik}
				/>
			)
		}
		if (field.id === 'vatNumber' && field.enableTaxisSearchRegistration) {
			return (
				<TaxisSearch
					searchFieldRef={searchFieldRef}
					onChange={fetchVisitors}
					options={options}
					field={field}
					textfieldProps={textfieldProps}
					loading={loading}
					searchAfterNoOfCharacters={3}
					handleOptions={handleOptions}
					onVisitorSelect={onVisitorSelect}
					interests={interests}
					postalCodeFieldRef={postalCodeFieldRef}
					enableSearch={enableSearch}
					values={values}
					formik={formik}
				/>
			)
		}
		if (field.id === 'email') {
			return (
				<>
					<Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
						<Box>
							{emailIsValid === EmailValid.Valid ? (
								<VerifiedOutlined color={'success'} sx={{marginRight: 0.5}}/>
							) : (emailIsValid === EmailValid.Error) ? (
								<Error color={'warning'}  sx={{marginRight: 0.5}}/>
							) : null}
						</Box>
						<Autocomplete
							searchFieldRef={searchFieldRef}
							onChange={fetchVisitors}
							display={'table'}
							options={options}
							searchFieldMappings={searchFieldMappings}
							defaultPreregistrationFields={defaultPreregistrationFields}
							field={field}
							textfieldProps={{
								...textfieldProps,
								sx: {
									...textfieldProps.sx,
									'& .MuiOutlinedInput-root': {
										'& fieldset': {
											borderColor: emailIsValid === EmailValid.Valid ? '#4caf50' : emailIsValid === EmailValid.Error ? '#ed6c02' : 'auto',
										},
										'&:hover fieldset': {
											borderColor: emailIsValid === EmailValid.Valid ? '#4caf50' : emailIsValid === EmailValid.Error ? '#ed6c02' : 'auto',
										},
										'&.Mui-focused fieldset': {
											borderColor: emailIsValid === EmailValid.Valid ? '#4caf50' : emailIsValid === EmailValid.Error ? '#ed6c02' : 'auto',
										},
									}
								}
							}}
							loading={loading}
							searchAfterNoOfCharacters={3}
							handleOptions={handleOptions}
							onVisitorSelect={onVisitorSelect}
							interests={interests}
							postalCodeFieldRef={postalCodeFieldRef}
							enableSearch={enableSearch}
							values={values}
							onBlur={validateEmail}
						/>
					</Box>
					{emailIsValid === EmailValid.Error && (
						<Typography variant="body2" sx={{ marginLeft: 1, color: '#ed6c02' }}>
							{t('Email may be incorrect.')}
						</Typography>
					)}
				</>
			)
		}
		
		return (
			<Autocomplete
				searchFieldRef={searchFieldRef}
				onChange={fetchVisitors}
				display={'table'}
				options={options}
				searchFieldMappings={searchFieldMappings}
				defaultPreregistrationFields={defaultPreregistrationFields}
				field={field}
				textfieldProps={textfieldProps}
				loading={loading}
				searchAfterNoOfCharacters={3}
				handleOptions={handleOptions}
				onVisitorSelect={onVisitorSelect}
				interests={interests}
				postalCodeFieldRef={postalCodeFieldRef}
				enableSearch={enableSearch}
				values={values}
			/>
		)
	}, [defaultCountry, defaultPhoneCode, emailIsValid, enableSearch, fetchVisitors, field, formik, handleOptions, interests, loading, onPhoneCodeChange, onVisitorSelect, options, phoneCodes, postalCodeFieldRef, searchFieldRef, t, textfieldProps, validateEmail, values])
	
	return fieldReturn
}

export default SearchVisitor
